<template>
  <v-dialog v-model="dialog" persistent max-width="1200px">
    <KTPortlet>
      <template v-slot:title>
        <h3 class="kt-portlet__head-title">{{ title }}</h3>
      </template>
      <template v-slot:toolbar>
        <v-btn icon dark @click="close">
          <v-icon dark color="black">mdi-close</v-icon>
        </v-btn>
      </template>
      <template v-slot:body>
        <b-row align-h="center" align-v="center">
          <b-col
            ><DateRange
              v-model="searchModel.dateRange"
              fieldName="actionDateSearch"
          /></b-col>
          <b-col
            ><b-row
              ><TextInput
                fieldName="userEmailSearch"
                v-model="searchModel.userEmail"
                label="User Email Search"
            /></b-row>
            <b-row>
              <MultiSelect
                fieldName="operationTypeSearch"
                v-model="searchModel.operationType"
                label="Action Search"
                :options="operationTypes"
                :multiple="false"/></b-row
          ></b-col>
        </b-row>
      </template>
      <template v-slot:foot>
        <div class="d-flex justify-content-between">
          <b-button type="button" @click="reset()" variant="primary"
            >Reset</b-button
          >
          <b-button type="button" @click="search()" variant="danger"
            >Search</b-button
          >
        </div>
      </template>
    </KTPortlet>
  </v-dialog>
</template>

<script>
import KTPortlet from "@/views/partials/content/Portlet";
import DateRange from "@/components/form-elements/search-components/DateRange.vue";
import TextInput from "@/components/form-elements/elements/TextInput.vue";
import MultiSelect from "@/components/form-elements/search-components/MultiSelect.vue";

export default {
  components: {
    KTPortlet,
    DateRange,
    TextInput,
    MultiSelect
  },
  props: {
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    title: {
      type: String,
      required: false,
      default: "Advanced Search"
    },
    operationTypesProp: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    },
    dialog: {
      type: Boolean,
      required: true,
      default: false
    }
  },
  data() {
    return {};
  },
  watch: {
    dialog(val) {
      if (val) {
        //onCreate
      } else {
        //onEnd
        this.close();
      }
    }
  },
  computed: {
    searchModel: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit("input", newVal);
      }
    },
    operationTypes() {
      const defaultArray = [{ value: "any", text: "Any" }];
      for (let key in this.operationTypesProp) {
        if (this.operationTypesProp.hasOwnProperty(key)) {
          defaultArray.push({
            value: key,
            text: this.operationTypesProp[key].text
          });
        }
      }
      return defaultArray;
    }
  },
  methods: {
    search() {
      this.$emit("search");
      this.close();
    },
    reset() {
      this.$emit("reset");
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss" scoped></style>
